import {
  FaCalendarAlt,
  FaDesktop,
  FaTools,
  FaBuilding,
  FaShieldAlt,
  FaServer,
  FaFlask,
  FaMicroscope,
  FaPencilAlt,
  FaBoxes,
  FaChartBar,
  FaClipboardList,
  FaCubes,
} from "react-icons/fa";

export const HOME_MENU = [
  {
    link: "/coe",
    title: "COE",
    description: "Update kegiatan yang sudah ada",
    icon: FaCalendarAlt,
    tone: "bg-indigo-50 text-indigo-600",
  },
  {
    link: "/monitoring",
    title: "Monitoring",
    description: "Cek kondisi ruangan",
    icon: FaDesktop,
    tone: "bg-teal-50 text-teal-600",
  },
  {
    link: "/perawatan-aset",
    title: "Perawatan Aset",
    description: "Jadwal dan status perawatan",
    icon: FaTools,
    tone: "bg-violet-50 text-violet-600",
  },
  {
    link: "/perawatan-bangunan",
    title: "Perawatan Bangunan",
    description: "Perawatan gedung dan ruang",
    icon: FaBuilding,
    tone: "bg-emerald-50 text-emerald-600",
  },
  {
    link: "/audit-keamanan",
    title: "Audit Keamanan",
    description: "Catatan audit perangkat",
    icon: FaShieldAlt,
    tone: "bg-rose-50 text-rose-600",
  },
  {
    link: "/perawatan-it",
    title: "Perawatan IT",
    description: "Perangkat IT yang dirawat",
    icon: FaServer,
    tone: "bg-slate-100 text-slate-600",
  },
  {
    link: "/inventaris-lab",
    title: "Inventaris Lab",
    description: "Barang di laboratorium",
    icon: FaFlask,
    tone: "bg-cyan-50 text-cyan-600",
  },
  {
    link: "/penggunaan-lab",
    title: "Peminjaman Lab",
    description: "Jadwal pemakaian lab",
    icon: FaMicroscope,
    tone: "bg-lime-50 text-lime-700",
  },
  {
    link: "/atk",
    title: "Alat Tulis",
    description: "Stok alat tulis kantor",
    icon: FaPencilAlt,
    tone: "bg-orange-50 text-orange-600",
  },
  {
    link: "/inventaris",
    title: "Inventaris",
    description: "Daftar aset inventaris",
    icon: FaBoxes,
    tone: "bg-sky-50 text-sky-600",
  },
  {
    link: "/statistik",
    title: "Statistik",
    description: "Ringkasan data aplikasi",
    icon: FaChartBar,
    tone: "bg-blue-50 text-blue-600",
  },
  {
    link: "/kartu-persediaan",
    title: "Kartu Persediaan",
    description: "Distribusi barang ke ruangan",
    icon: FaClipboardList,
    tone: "bg-amber-50 text-amber-700",
    sidebar: false,
  },
  {
    link: "/material-keluar",
    title: "Material Keluar",
    description: "Pemakaian material gedung",
    icon: FaCubes,
    tone: "bg-stone-100 text-stone-700",
    sidebar: false,
  },
];
